import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { EmployerResource } from './Employer';

/**
 * Relationship classes
 */
export class ConnectorAttributes {
  id: string = null;
}

export class ConnectorBelongsTo {
  employer: () => EmployerResource = () => new EmployerResource();
}

export class ConnectorHasOne {}
export class ConnectorHasMany {}

/**
 * Utility interfaces
 */
export interface ConnectorMethods {}

export interface ConnectorInterface
  extends ConnectorAttributes,
    ConnectorBelongsTo,
    ConnectorType {}

type ConnectorType = GConstructor<ConnectorInterface>;

export interface ConnectorResource
  extends Base<ConnectorAttributes>,
    ConnectorInterface,
    ConnectorMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<ConnectorAttributes>({
    queryName: 'connectors',
    className: 'Connector',
    AttributesClass: ConnectorAttributes,
    BelongsToClasses: [
      {
        Klass: ConnectorBelongsTo,
      },
    ],
  });

export const ConnectorResourceClass = <TBase extends ConnectorType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements ConnectorMethods {};

export class ConnectorResource extends ClassExtender<ConnectorInterface>(
  BaseClass,
  ConnectorResourceClass,
) {}

/**
 * Resource instance
 */
export const Connector = APILibrary.createResource<ConnectorResource>(ConnectorResource);
